import { setTokenCookie } from './cookie'

class TokenHolder {
  token: string | null = ''

  tokenGetter: (() => Promise<string> | string) | null = null

  setToken = (accessToken: string | null) => {
    this.token = accessToken
  }

  setTokenGetter = (handler: typeof this.tokenGetter) => {
    this.tokenGetter = handler
  }

  getToken = async () => {
    let { token } = this

    if (this.tokenGetter) {
      try {
        token = await this.tokenGetter()
      } catch (error) {
        token = null
      }
    }

    if (!token) {
      try {
        const auth0Keys = Object.keys(localStorage).filter((key) => {
          if (!key.startsWith('@@auth0spajs@@')) return false

          // Auth0 localStorage keys use '::' as delimiters. Examples:
          // @@auth0spajs@@https://auth.example.com::clientId::audience::scope
          // or @@auth0spajs@@::clientId::https://auth.example.com::scope
          // Strategy: strip the prefix, split on '::', find the first segment
          // that looks like a URL (contains '://'), and parse that.
          const stripped = key.slice('@@auth0spajs@@'.length)
          const parts = stripped.split('::').filter(Boolean)
          const originCandidate = parts.find((part) => part.includes('://'))

          // If the originCandidate exists but fails URL parsing (malformed),
          // try to extract a cleaner URL-like substring (stop at '@' or whitespace).
          if (originCandidate) {
            try {
              const urlObj = new URL(originCandidate)
              return (
                urlObj.hostname === 'petabyte.vet' ||
                urlObj.hostname.endsWith('.petabyte.vet')
              )
            } catch (e) {
              const fallback = originCandidate.match(/https?:\/\/[^@\s]+/)?.[0]
              if (fallback) {
                try {
                  const urlObj = new URL(fallback)
                  return (
                    urlObj.hostname === 'petabyte.vet' ||
                    urlObj.hostname.endsWith('.petabyte.vet')
                  )
                } catch (_) {
                  return false
                }
              }
              return false
            }
          }

          return false
        })

        if (auth0Keys.length > 0) {
          const auth0Data = localStorage.getItem(auth0Keys[0])
          if (auth0Data) {
            const parsedData = JSON.parse(auth0Data)
            const accessToken = parsedData.body?.access_token
            if (accessToken) {
              token = accessToken
            }
          }
        }
      } catch (error) {
        // Don't throw, just ignore and continue if localStorage access fails
        // token will remain null
      }
    }

    setTokenCookie(token)
    return token
  }
}

export const tokenHolder = new TokenHolder()
